import { createSelector } from '@reduxjs/toolkit';
import { selectAvailableRegions } from './selectAvailableRegions';

export const selectRegionsOptions = createSelector(selectAvailableRegions, state =>
  state.map(({ id, name }) => ({ value: id.toString(), label: name })),
);
